<h1 mat-dialog-title>Keyword Suggestions <span *ngIf="selectedKeywords.length > 0" style="font-size: 14px; color: #666;">({{selectedKeywords.length}} selected)</span></h1>

<div mat-dialog-content class="keyword-suggest" style="min-height: 500px; position: relative;">
  <div style="margin-bottom: 16px; display: flex; align-items: center; gap: 8px;">
    <mat-form-field appearance="standard" style="flex: 1;">
      <mat-label>Keyword <span *ngIf="keywordSource">(from {{keywordSource}})</span></mat-label>
      <input matInput [formControl]="keywordControl" autocomplete="off" trim="blur" required (keydown.enter)="onGetSuggestions()">
      <mat-error *ngIf="keywordControl.hasError('required')">
        Keyword is required
      </mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="onGetSuggestions()" [disabled]="!keywordControl.valid || isLoading">
      <mat-icon *ngIf="!isLoading">search</mat-icon>
      <mat-icon *ngIf="isLoading" class="spinner">refresh</mat-icon>
      Suggest
    </button>
    <button mat-icon-button (click)="resetTable()" [disabled]="!hasSearched || isLoading" matTooltip="Refresh table">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div *ngIf="!isLoading && suggestions.length > 0" class="table-container">
      <div class="table-scroll-wrapper">
        <table mat-table [dataSource]="paginatedSuggestions" class="mat-elevation-z2" style="width: 100%;">
          <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox 
              color="primary"
              [checked]="allSelected"
              [indeterminate]="someSelected"
              (change)="toggleSelectAll()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox 
              color="primary"
              [checked]="element.selected"
              (change)="toggleSelection(element)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="keyword">
          <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="sortBy('keyword')">
            Keyword
            <span class="sort-indicators">
              <span class="sort-arrow sort-up" [class.active]="getSortState('keyword') === 'asc'" [class.faded]="!getSortState('keyword')">▲</span>
              <span class="sort-arrow sort-down" [class.active]="getSortState('keyword') === 'desc'" [class.faded]="!getSortState('keyword')">▼</span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element">{{element.keyword}}</td>
        </ng-container>

        <ng-container matColumnDef="search_volume">
          <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="sortBy('search_volume')">
            Search Volume
            <span class="sort-indicators">
              <span class="sort-arrow sort-up" [class.active]="getSortState('search_volume') === 'asc'" [class.faded]="!getSortState('search_volume')">▲</span>
              <span class="sort-arrow sort-down" [class.active]="getSortState('search_volume') === 'desc'" [class.faded]="!getSortState('search_volume')">▼</span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element">{{(element.search_volume || 0) | number}}</td>
        </ng-container>

        <ng-container matColumnDef="competition">
          <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="sortBy('competition')">
            Competition
            <span class="sort-indicators">
              <span class="sort-arrow sort-up" [class.active]="getSortState('competition') === 'asc'" [class.faded]="!getSortState('competition')">▲</span>
              <span class="sort-arrow sort-down" [class.active]="getSortState('competition') === 'desc'" [class.faded]="!getSortState('competition')">▼</span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element">{{element.competition || 0}}</td>
        </ng-container>

        <ng-container matColumnDef="competition_level">
          <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="sortBy('competition_level')">
            Competition Level
            <span class="sort-indicators">
              <span class="sort-arrow sort-up" [class.active]="getSortState('competition_level') === 'asc'" [class.faded]="!getSortState('competition_level')">▲</span>
              <span class="sort-arrow sort-down" [class.active]="getSortState('competition_level') === 'desc'" [class.faded]="!getSortState('competition_level')">▼</span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="competition-badge" [ngClass]="'level-' + element.competition_level?.toLowerCase()">
              {{element.competition_level}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="cpc">
          <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="sortBy('cpc')">
            CPC
            <span class="sort-indicators">
              <span class="sort-arrow sort-up" [class.active]="getSortState('cpc') === 'asc'" [class.faded]="!getSortState('cpc')">▲</span>
              <span class="sort-arrow sort-down" [class.active]="getSortState('cpc') === 'desc'" [class.faded]="!getSortState('cpc')">▼</span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element">${{element.cpc || 0}}</td>
        </ng-container>

        <ng-container matColumnDef="keyword_difficulty">
          <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="sortBy('keyword_difficulty')">
            KW Difficulty
            <span class="sort-indicators">
              <span class="sort-arrow sort-up" [class.active]="getSortState('keyword_difficulty') === 'asc'" [class.faded]="!getSortState('keyword_difficulty')">▲</span>
              <span class="sort-arrow sort-down" [class.active]="getSortState('keyword_difficulty') === 'desc'" [class.faded]="!getSortState('keyword_difficulty')">▼</span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element">{{element.keyword_difficulty || 0}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-progress-bar *ngIf="isTableLoading" mode="indeterminate" class="table-progress-bar"></mat-progress-bar>
      </div>
      
      <mat-paginator 
        [length]="filteredSuggestions.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[25, 50, 100]"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
  </div>

  <div *ngIf="!isLoading && !hasSearched" class="empty-state">
    <mat-icon class="empty-icon">search</mat-icon>
    <h3>Ready to Find Keywords</h3>
    <p>Enter a keyword above and click "Suggest" to discover related keyword suggestions with metrics.</p>
  </div>

  <div *ngIf="!isLoading && hasSearched && suggestions.length === 0" class="empty-state">
    <mat-icon class="empty-icon" color="warn">search_off</mat-icon>
    <h3>No Suggestions Found</h3>
    <p>We couldn't find any keyword suggestions for "{{keywordControl.value}}". Try a different keyword.</p>
  </div>

  <div *ngIf="isLoading" class="loading-overlay">
    <div style="width: 100%; height: 100%; padding: 0 24px;">
      <ngx-skeleton-loader count="8" [theme]="{'border-radius': '4px', height: '48px', 'margin-bottom': '4px'}"></ngx-skeleton-loader>
    </div>
  </div>
</div>

<div mat-dialog-actions style="display: flex; justify-content: space-between; align-items: center;">
  <div>
    <span *ngIf="selectedKeywords.length > 0" style="color: #666; font-size: 14px;">
      {{selectedKeywords.length}} keyword(s) selected
    </span>
  </div>
  <div style="display: flex; gap: 8px; align-items: center;">
    <button mat-raised-button color="primary" [matMenuTriggerFor]="addMenu" [disabled]="selectedKeywords.length === 0">
      <mat-icon>add</mat-icon>
      Add to Keyword Mapping
    </button>
    <mat-menu #addMenu="matMenu">
      <button mat-menu-item (click)="addAsPrimary()">
        <mat-icon>star</mat-icon>
        <span>Add as Primary</span>
      </button>
      <button mat-menu-item (click)="addAsSecondary()">
        <mat-icon>star_border</mat-icon>
        <span>Add as Secondary</span>
      </button>
    </mat-menu>
    <button mat-button (click)="onCancel()">Close</button>
  </div>
</div>
